export default "__VITE_ASSET__CTp7SnFQ__"